<template>
  <section :class="$style.union_team_list">
    <div :class="$style.union_team_list_content">
      <app-prev-button @click="$router.go(-1)" />
      <div :class="$style.list_table_wrap">
        <div v-if="isLoading" :class="$style.loading">
          <base-icon name="spinner" size="24px" spin />
        </div>
        <div v-else>
          <!-- <h2 :class="$style.union_info_title">ゆにおん</h2> -->

          <div :class="$style.union_info">
            <div :class="$style.union_info_row">
              <span :class="$style.union_info_label">ゆにおん名</span>
              <span :class="$style.union_info_value">{{ unionName }}</span>
            </div>
            <div v-if="unionKey" :class="$style.union_info_row">
              <span :class="$style.union_info_label">ゆにおんキー</span>
              <span :class="$style.union_info_value">
                {{ unionKey }}
                <span style="display:inline-block;width:8px;"></span>
                <base-button rounded="rounded" width="75px" height="20px" @click="copyUnionKey">コピー</base-button>
                <span :class="$style.union_key_desc">※ ログインページ下部の「シングルサインオン」リンク先ページで、ゆにおんキーを入力してください。</span>
              </span>
            </div>
            <div v-if="idProviders.length > 0" :class="$style.union_info_row">
              <span :class="$style.union_info_label">IDプロバイダ</span>
              <span :class="$style.union_info_value">
                <ul :class="$style.idp_list">
                  <li v-for="(idp, idx) in idProviders" :key="idx" :class="$style.idp_item">
                    <span :class="$style.idp_name">{{ idp.name }}：</span>
                    <span>{{ idp.url }}</span>
                    <base-button rounded="rounded" width="75px" height="20px"
                      @click="copyUrl(idp.url)">コピー</base-button>
                  </li>
                </ul>
                <span :class="$style.union_key_desc">※ これはIDプロバイダのログインページURLです。くみあいアプリのシングルサインオンに利用できます。</span>
                <span v-if="isSsoLoginOnly" :class="$style.union_key_desc">※
                  IDプロバイダが設定されているゆにおんに紐づくユーザーは、くみあいアプリの通常のログインページからはログインできません。IDプロバイダ経由でログインしてください。</span>
              </span>
            </div>
            <div :class="$style.union_info_row">
              <span :class="$style.union_info_label">認証セキュリティ強化</span>
              <span :class="$style.union_info_value">{{ tfaEnabledFlg ? 'ON' : 'OFF' }}</span>
            </div>
          </div>
          <div :class="$style.list_table_header">
            <h2 :class="$style.list_table_header_title">チーム一覧</h2>
            <div :class="$style.list_table_header_total">
              <span>{{ totalRowCount }}</span>&nbsp;{{ totalRowCount != null ? '件' : '' }}
            </div>
          </div>
          <div :class="$style.list_table">
            <app-table-list :col-defs="tableColDefs" :row-data="tableRowData" :page="tablePageIndex" :no-sort="true"
              :fetch-mode="true" :page-data-num="perPage" :total-record="total" :no-margin-b="true" :selectable="false"
              @page-no-click="paginate">
            </app-table-list>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppPrevButton from '@/components/app/AppPrevButton/AppPrevButton'
import AppTableList from '@/components/app/AppTableList/AppTableList'
import BaseIcon from '@/components/base/BaseIcon/BaseIcon'
import BaseButton from '@/components/base/BaseButton/BaseButton'
export default {
  name: 'UnionTeamList',
  components: { AppPrevButton, AppTableList, BaseIcon, BaseButton },
  mounted() {
    this.$router.app.$emit('page-updated', {
      pageTitle: 'ゆにおん詳細',
      showSetting: false,
      back: '/',
      headerColor: 'white',
      bgColor: 'gray'
    })
    const unionCode = this.$route.params.union_code;
    this.fetchUnionInfo(unionCode);
    this.fetchTeamList(unionCode);
  },
  data() {
    return {
      unionName: '',
      unionKey: '',
      tfaEnabledFlg: false,
      idProviders: [],
      isSsoLoginOnly: false,
      tableColDefs: [
        { key: 'team_id', label: 'ID' },
        { key: 'team_code', label: '認証基盤の組織コード' },
        { key: 'team_name', label: '組織名' },
        { key: 'storage_used', label: 'ストレージ使用量' },
        { key: 'team_member_count', label: 'チーム人数' },
      ],
      tableRowData: [],
      tablePageIndex: 1,
      total: null,
      perPage: 10,
      isLoading: true,
    }
  },
  methods: {
    async fetchUnionInfo(unionCode) {
      try {
        const result = await this.$axios.get(`/api/${this.$constants.API_VERSION}/union/info`, {
          params: {
            union_code: unionCode
          },
        });

        if (result.data && result.data.value) {
          const unionData = result.data.value;
          this.unionName = unionData.union_name || '';
          this.unionKey = unionData.union_key || '';
          this.isSsoLoginOnly = unionData.is_sso_login_only === 1;
          this.tfaEnabledFlg = unionData.tfa_enabled_flg === 1;

          // IDプロバイダ情報を整形
          if (unionData.idp_list && Array.isArray(unionData.idp_list)) {
            this.idProviders = unionData.idp_list.map(idp => ({
              name: idp.key || '',
              url: idp.idp_login_url || ''
            }));
          } else {
            this.idProviders = [];
          }
        }
      } catch (error) {
        console.error('Union情報取得中にエラーが発生しました:', error);
      }
    },
    async fetchTeamList(unionCode) {
      this.isLoading = true;
      try {
        const result = await this.$axios.get(`/api/${this.$constants.API_VERSION}/union/${unionCode}/team`, {
          params: {
            page: this.tablePageIndex
          },
        });

        if (result.data && result.data.teams) {
          this.tableRowData = result.data.teams;
          this.tablePageIndex = result.data.pagination.current_page;
          this.total = result.data.pagination.total;
        } else {
          this.tableRowData = [];
          this.total = 0;
        }
      } catch (error) {
        console.error('データ取得中にエラーが発生しました:', error);
        this.tableRowData = [];
        this.total = 0;
      } finally {
        this.isLoading = false;
      }
    },
    paginate(listPage) {
      this.tablePageIndex = Number(listPage);
      this.fetchTeamList(this.$route.params.union_code);
    },
    copyUrl(url) {
      navigator.clipboard.writeText(url).then(() => {
        alert('URLをコピーしました');
      });
    },
    copyUnionKey() {
      navigator.clipboard.writeText(this.unionKey).then(() => {
        alert('ゆにおんキーをコピーしました');
      });
    },
  },
  computed: {
    totalRowCount() {
      return this.total == null ? '' : this.total;
    },
  },
}
</script>

<style lang="scss" module>
.union_team_list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  padding-top: 12px;
  padding-left: 20px;
  padding-right: 20px;
}

.union_team_list_content {
  width: 100%;
}

.list_table_wrap {
  width: 100%;

  .list_table_header {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 0px;

    &_title {
      font-size: 20px;
      margin: 0 20px 0 0;
    }

    &_total {
      margin-right: auto;
      font-size: 16px;

      span {
        font-weight: bold;
      }
    }

    &>*:last-child {
      margin-left: 20px;
    }
  }

  .list_table th,
  .list_table td {
    min-width: 150px;
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.union_info {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 16px 20px;

  &_title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  &_row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 18px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &_label {
    min-width: 100px;
    font-weight: bold;
    color: #555;
    margin-right: 12px;
    line-height: 32px;
  }

  &_value {
    color: #222;
    font-size: 15px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    line-height: 32px;
  }
}

.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.idp_list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.idp_item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}

.idp_name {
  font-weight: bold;
  color: #333;
}

.idp_url {
  color: #1976d2;
  text-decoration: underline;
  font-size: 13px;
  word-break: break-all;
}

.idp_copy_btn {
  margin-left: 6px;
  padding: 2px 8px;
  font-size: 12px;
  background: #f0f0f0;
  border: 1px solid #bbb;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.idp_copy_btn:hover {
  background: #e0e0e0;
}

.union_key_desc {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #888;
  line-height: 1.4;
  width: 100%;
}
</style>
